export default "__VITE_ASSET__95e502f2__"